// src/components/Toolbar.jsx
import React from "react";

const ToolbarPage = ({ actions }) => {
  return (
    <div
      style={{
        display: "flex",
        gap: "8px",
        marginBottom: "16px",
      }}
    >
      {actions.map((action, index) => (
        <button
          key={index}
          onClick={action.onClick}
          style={{
            padding: "6px 12px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          {action.label}
        </button>
      ))}
    </div>
  );
};

export default ToolbarPage;
